<template>
  <!--==================
    component shows and manage all operator tours (operator)
    ===============-->

  <div id="tour-list-page" class="position-relative">
    <div class="pb-4 d-flex justify-content-between">
      <input
        class="form-control"
        placeholder="Search by id"
        v-model="packageSearch"
        type="number"
        style="max-width: 300px"
      />
      <a class="btn btn-sm btn-primary" href="tour/add" target="_blank">Add Tour</a>
    </div>
    <div class="mt-4 row">
      <div v-if="!filteredPackageById.length" class="alert alert-info col text-center" role="alert">
        <span class="font-italic">no tour found for this account, to add tour click "Add Tour" button!</span>
      </div>
      <div
        v-for="(tour, index) in filteredPackageById.slice((pageNumber - 1) * cardPerPage, pageNumber * cardPerPage)"
        :key="tour.id"
        class="col-md-4 col-sm-6 col-xs-12 col-lg-4 px-3"
      >
        <div class="card">
          <img class="card-img-top tour-card-img" :src="tour.image" />
          <div class="card-body d-flex flex-column">
            <a :href="packageUrl + tour.id" target="_blank" class="font-weight-bold h5">
              {{ tour.noOfDay }}-Day {{ tour.title }}
            </a>

            <div class="row mt-4 mb-2">
              <div class="d-flex justify-content-between col-12">
                <div class="input-group mb-2 col-5 p-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text p-1 rounded-0">ID</div>
                  </div>
                  <input type="text" class="form-control form-control-sm rounded-0" :value="tour.id" disabled />
                </div>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text p-1 rounded-0">PRICE</div>
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-sm rounded-0 text-center"
                    :value="tour.price | currency"
                    disabled
                  />
                </div>
              </div>
              <div class="d-flex justify-content-between col-12">
                <div class="form-group col px-0">
                  <select
                    class="form-control form-control-sm"
                    :value="tour.status"
                    :data-id="tour.id"
                    @change="updateStatus($event)"
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div class="form-group col text-right px-0">
                  <div class="btn-group">
                    <button
                      :id="'dropdown-menu-' + index"
                      class="btn btn-secondary btn-sm dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <div class="dropdown-menu" :aria-labelledby="'dropdown-menu-' + index">
                      <button
                        class="dropdown-item"
                        @click="updatePackage($event)"
                        :data-index="index"
                        :data-id="tour.id"
                      >
                        Edit
                      </button>
                      <button
                        class="dropdown-item"
                        @click="clonePackage($event)"
                        :data-index="index"
                        :data-id="tour.id"
                      >
                        Clone
                      </button>
                      <button
                        class="dropdown-item"
                        @click="previewPackage($event)"
                        :data-index="index"
                        :data-id="tour.id"
                      >
                        Preview
                      </button>
                      <button
                        class="dropdown-item"
                        @click="addPackageActivity($event)"
                        :data-index="index"
                        :data-id="tour.id"
                      >
                        Add Activities<span class="badge badge-danger ml-2">In developing</span>
                      </button>
                      <button
                        class="dropdown-item"
                        @click="removePackage($event)"
                        :data-id="tour.id"
                        :data-index="index"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p
            v-if="tour.status && !tour.published"
            class="text-info text-center mb-0 mt-auto"
            title="This package waiting to be aproved by safari-trek-beach, to be visible on website."
          >
            Unproved <i class="icofont-info-circle"></i>
          </p>
        </div>
      </div>
    </div>
    <paginate
      v-if="filteredPackageById.length"
      v-model="pageNumber"
      :page-count="Math.ceil(filteredPackageById.length / cardPerPage)"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :container-class="'pagination mt-3'"
      :page-class="'page-item'"
      :prev-class="'page-link'"
      :next-class="'page-link'"
      :page-link-class="'page-link'"
    />
  </div>
</template>
<style scoped>
.pagination {
  justify-content: center;
}
</style>
<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";

export default {
  name: "TourOperator",
  components: {
    Paginate,
  },

  data() {
    return {
      pageNumber: 1,
      cardPerPage: 12,
      packageSearch: "",
      filteredPackageById: [],
    };
  },

  computed: {
    ...mapGetters(["user", "operatorPackages", "token"]),

    tourPackages() {
      let sortedTours = this.operatorPackages;

      // sort tours by last updated date
      sortedTours.forEach((tour) => {
        if (tour.rates.adult.length) {
          tour["price"] = tour.rates.adult[0].currencyWinter;
        } else {
          tour["price"] = 0;
        }
      });
      sortedTours.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

      return sortedTours;
    },

    packageUrl() {
      return process.env.VUE_APP_PACKAGE_URL;
    },
  },

  watch: {
    pageNumber: function (oldVal, newVal) {
      this.goTop();
    },

    packageSearch: function () {
      this.pageNumber = 1;
      if (this.packageSearch && this.tourPackages != undefined) {
        this.filteredPackageById = this.tourPackages.filter((item) => {
          return item.id == this.packageSearch;
        });
      } else {
        this.filteredPackageById = this.tourPackages;
      }
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchOperatorPackages(this.user.id);
      this.filteredPackageById = this.tourPackages;
      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions(["fetchOperatorPackages", "updatePackageStatus", "deletePackage", "hideBarLoading"]),

    async updateStatus(e) {
      let id = e.target.getAttribute("data-id");
      let status = e.target.value;

      this.updatePackageStatus({ id, status });
    },

    removePackage(e) {
      let id = e.target.getAttribute("data-id");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this package?",
        buttons: {
          confirm: async () => {
            await dP.deletePackage(id);
            dP.fetchOperatorPackages(this.user.id);
          },
          cancel: () => {},
        },
      });
    },

    updatePackage(e) {
      let id = e.target.getAttribute("data-id");
      window.open("/dashboard/tour/edit/" + id, "_blank");
    },

    clonePackage(e) {
      let id = e.target.getAttribute("data-id");
      window.open("/dashboard/tour/clone/" + id, "_blank");
    },

    previewPackage(e) {
      let id = e.target.getAttribute("data-id");
      window.open(process.env.VUE_APP_PREVIEW_PACKAGE_URL + id + "?preivewId=" + this.token, "_blank");
    },

    addPackageActivity(e) {
      let id = e.target.getAttribute("data-id");
      window.open("/dashboard/tour/activity/" + id, "_blank");
    },

    goTop() {
      setTimeout(() => {
        $("html, body").animate(
          {
            scrollTop: $("#tour-list-page").offset().top - 40 + "px",
          },
          500
        );
      }, 100);
    },
  },
};
</script>
